module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"notes":"Release notes","features":"Features","fix":"Fixes"},"fr":{"notes":"Notes de version","features":"Fonctionnalités","fix":"Corrections"}}')
  delete Component.options._Ctor
}
